import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'

const CERT_SIZE = {
  wideBar: '80mm 40mm',
  wideQr: '80mm 40mm',
  tall: '60mm 40mm',
  tallMark: '60mm 40mm',
  short: '50mm 40mm'
}
const CERT_TENTH = { wideBar: [800, 400], wideQr: [800, 400], tall: [600, 400], tallMark: [600, 400], short: [500, 400] }

export function certSize(style) {
  return CERT_SIZE[style] || CERT_SIZE.wideBar
}

export function loadCLodop() {
  if (typeof window === 'undefined' || window.getCLodop || window.__clodopLoading) return
  window.__clodopLoading = true
  const https = location.protocol === 'https:'
  const srcs = https
    ? ['https://localhost.lodop.net:8443/CLodopfuncs.js', 'https://localhost:8443/CLodopfuncs.js']
    : ['http://localhost:8000/CLodopfuncs.js', 'http://localhost:18000/CLodopfuncs.js']
  srcs.forEach((src, index) => {
    const script = document.createElement('script')
    script.src = src + '?priority=' + (srcs.length - index)
    script.async = false
    script.onerror = () => {}
    document.head.appendChild(script)
  })
}

function clodop() {
  try { return window.getCLodop?.() || window.LODOP || null } catch { return null }
}

export async function printPrefs() {
  const http = (await import('../api/http')).default
  try {
    const data = await http.get('/settings')
    return { ...(data.settings || {}), factoryName: data.factory?.name || '' }
  } catch {
    return {}
  }
}

function esc(value) {
  return String(value ?? '').replace(/[&<>"]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]))
}

export function code128Svg(value, options = {}) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  JsBarcode(svg, String(value || '0'), {
    format: 'CODE128',
    displayValue: !!options.displayValue,
    fontSize: options.fontSize || 12,
    textMargin: 1,
    height: options.height || 40,
    margin: 0,
    width: options.width || 1.4,
    background: '#ffffff',
    lineColor: '#111111'
  })
  svg.setAttribute('preserveAspectRatio', 'xMinYMid meet')
  return svg.outerHTML
}

export async function qrSvg(value) {
  const svg = await QRCode.toString(String(value || '0'), {
    type: 'svg',
    margin: 0,
    errorCorrectionLevel: 'M',
    width: 96
  })
  return svg.replace(/<\?xml[\s\S]*?\?>/, '')
}

function clock(date = new Date()) {
  const p = n => String(n).padStart(2, '0')
  return {
    md: `${p(date.getMonth() + 1)}.${p(date.getDate())}`,
    mdhm: `${p(date.getMonth() + 1)}.${p(date.getDate())} ${p(date.getHours())}:${p(date.getMinutes())}`,
    ymdhm: `${String(date.getFullYear()).slice(2)}/${p(date.getMonth() + 1)}/${p(date.getDate())} ${p(date.getHours())}:${p(date.getMinutes())}`
  }
}

function slotOf(order, garment) {
  return order?.shelfNo || garment?.shelf || ''
}

function piece(garment, index, total, withAttach) {
  const accessory = withAttach && garment.accessory && garment.accessory !== '无配件' ? garment.accessory : ''
  return {
    title: [garment.name, `${index}/${total}`, accessory, garment.color].filter(Boolean).join(' '),
    care: [garment.defect, garment.washType].filter(Boolean).join('，'),
    accessory: accessory ? `附件：${accessory}` : ''
  }
}

function who(order) {
  return [order?.receiverName, order?.phone].filter(Boolean).join(' ')
}

function shopOf(ctx) {
  return ctx.store?.printTitle || ctx.store?.name || ctx.factoryName || ''
}

function text(lp, top, left, width, height, value, opt = {}) {
  lp.ADD_PRINT_TEXT(top, left, width, height, value || '')
  lp.SET_PRINT_STYLEA(0, 'FontName', '微软雅黑')
  lp.SET_PRINT_STYLEA(0, 'FontSize', opt.size || 7)
  if (opt.bold) lp.SET_PRINT_STYLEA(0, 'Bold', 1)
  if (opt.align) lp.SET_PRINT_STYLEA(0, 'Alignment', opt.align)
}

function nativeCode(lp, top, left, width, height, kind, value, angle) {
  lp.ADD_PRINT_BARCODE(top, left, width, height, kind === 'qr' ? 'QRCode' : '128Auto', String(value || '0'))
  if (kind === 'qr') lp.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'M')
  else lp.SET_PRINT_STYLEA(0, 'ShowBarText', 0)
  if (angle) lp.SET_PRINT_STYLEA(0, 'Angle', angle)
}

function begin(lp, name, tenth, printer) {
  lp.PRINT_INIT(name)
  lp.SET_PRINT_PAGESIZE(1, tenth[0], tenth[1], '')
  if (printer && lp.SET_PRINTER_INDEXA) lp.SET_PRINTER_INDEXA(printer)
  else if (printer) lp.SET_PRINTER_INDEX(printer)
}

export async function printWash(garments, ctx, withAttach = true) {
  const list = garments || []
  if (!list.length) return false
  const style = ctx.print_wash_style === 'qr' ? 'qr' : 'barcode'
  const preferBrowser = ctx.print_prefer_browser === '1' || ctx.forceBrowser
  const lp = preferBrowser ? null : clodop()
  if (lp) {
    try {
      begin(lp, '水洗唛', [1000, 200], ctx.printer_wash)
      list.forEach((garment, index) => {
        if (index) lp.NEWPAGE()
        drawWash(lp, garment, index, list.length, ctx, style, withAttach)
      })
      lp.PRINT()
      return true
    } catch { /* 控件没连上时改走浏览器 */ }
  }
  const html = (await Promise.all(list.map((garment, index) => washHtml(garment, index, list.length, ctx, style, withAttach)))).join('')
  return openHtml(html, '100mm 20mm')
}

function drawWash(lp, garment, index, total, ctx, style, withAttach) {
  const time = clock()
  const info = piece(garment, index + 1, total, withAttach)
  text(lp, '0.8mm', '2mm', '70mm', '3.5mm', ctx.factoryName || shopOf(ctx) || '工厂')
  if (style === 'qr') {
    nativeCode(lp, '4.5mm', '2mm', '14mm', '14mm', 'qr', garment.barcode)
    text(lp, '4.6mm', '17mm', '18mm', '3.5mm', garment.barcode, { size: 7, bold: 1 })
    text(lp, '8.2mm', '17mm', '18mm', '3.5mm', time.md)
  } else {
    nativeCode(lp, '4.2mm', '2mm', '34mm', '9mm', 'barcode', garment.barcode)
    text(lp, '13.6mm', '2mm', '22mm', '3.5mm', garment.barcode, { size: 7 })
    text(lp, '13.6mm', '22mm', '14mm', '3.5mm', time.md)
  }
  text(lp, '4.4mm', '38mm', '46mm', '3.6mm', who(ctx.order), { size: 8, bold: 1 })
  text(lp, '8.2mm', '38mm', '46mm', '3.6mm', info.title)
  text(lp, '12mm', '38mm', '46mm', '4mm', info.care)
  text(lp, '4mm', '84mm', '14mm', '14mm', slotOf(ctx.order, garment), { size: 16, bold: 1 })
}

async function washHtml(garment, index, total, ctx, style, withAttach) {
  const time = clock()
  const info = piece(garment, index + 1, total, withAttach)
  const mark = style === 'qr'
    ? `<div class="qr">${await qrSvg(garment.barcode)}<div><b>${esc(garment.barcode)}</b><div>${time.md}</div></div></div>`
    : `<div class="bars">${code128Svg(garment.barcode, { displayValue: false, height: 28 })}<div class="under"><span>${esc(garment.barcode)}</span><span>${time.md}</span></div></div>`
  return `<section class="wash"><div class="top"><span>${esc(ctx.factoryName || shopOf(ctx) || '工厂')}</span></div><div class="row">${mark}<div class="info"><div class="who">${esc(who(ctx.order))}</div><div>${esc(info.title)}</div><div>${esc(info.care)}</div></div><b class="slot">${esc(slotOf(ctx.order, garment))}</b></div></section>`
}

export async function printCert(garment, ctx, index, total) {
  if (!garment) return false
  const style = CERT_SIZE[ctx.print_cert_style] ? ctx.print_cert_style : 'wideBar'
  const preferBrowser = ctx.print_prefer_browser === '1' || ctx.forceBrowser
  const lp = preferBrowser ? null : clodop()
  if (lp) {
    try {
      begin(lp, '合格证', CERT_TENTH[style], ctx.printer_certificate)
      drawCert(lp, garment, index, total, ctx, style)
      lp.PRINT()
      return true
    } catch { /* 改走浏览器 */ }
  }
  return openHtml(await certHtml(garment, ctx, index, total, style), certSize(style))
}

function drawCert(lp, garment, index, total, ctx, style) {
  const time = clock()
  const info = piece(garment, index, total, ctx.withAttach !== false)
  const slot = slotOf(ctx.order, garment)
  const shop = shopOf(ctx)
  const customer = who(ctx.order)
  const showQi = !!ctx.showQi
  if (style === 'wideBar') {
    nativeCode(lp, '2mm', '2mm', '58mm', '12mm', 'barcode', garment.barcode)
    text(lp, '2mm', '62mm', '16mm', '10mm', slot, { size: 16, bold: 1 })
    text(lp, '15mm', '2mm', '28mm', '4mm', garment.barcode, { size: 8 })
    text(lp, '15mm', '30mm', '30mm', '4mm', time.mdhm)
    text(lp, '20mm', '2mm', '76mm', '4mm', info.title)
    text(lp, '24mm', '2mm', '76mm', '5mm', info.care)
    text(lp, '30mm', '2mm', '46mm', '4mm', customer)
    text(lp, '34mm', '2mm', '40mm', '4mm', shop, { bold: 1 })
    if (showQi) text(lp, '30mm', '70mm', '8mm', '6mm', '齐', { size: 12, bold: 1 })
  } else if (style === 'wideQr') {
    nativeCode(lp, '2mm', '2mm', '16mm', '16mm', 'qr', garment.barcode)
    text(lp, '3mm', '20mm', '40mm', '6mm', garment.barcode, { size: 12, bold: 1 })
    text(lp, '10mm', '20mm', '36mm', '4mm', time.mdhm)
    text(lp, '2mm', '62mm', '16mm', '10mm', slot, { size: 16, bold: 1 })
    text(lp, '20mm', '2mm', '76mm', '4mm', info.title)
    text(lp, '24mm', '2mm', '76mm', '5mm', info.care)
    text(lp, '30mm', '2mm', '46mm', '4mm', customer)
    text(lp, '34mm', '2mm', '40mm', '4mm', shop, { bold: 1 })
    if (showQi) text(lp, '30mm', '70mm', '8mm', '6mm', '齐', { size: 12, bold: 1 })
  } else if (style === 'short') {
    text(lp, '1.5mm', '2mm', '30mm', '6mm', slot, { size: 14, bold: 1 })
    text(lp, '8mm', '2mm', '46mm', '4mm', info.title)
    text(lp, '12mm', '2mm', '46mm', '4mm', info.accessory || info.care)
    nativeCode(lp, '17mm', '2mm', '46mm', '12mm', 'barcode', garment.barcode)
    text(lp, '30mm', '2mm', '24mm', '4mm', garment.barcode, { size: 7 })
    text(lp, '30mm', '24mm', '16mm', '4mm', time.mdhm, { size: 6 })
    if (showQi) text(lp, '30mm', '40mm', '8mm', '6mm', '齐', { size: 12, bold: 1 })
    text(lp, '34mm', '2mm', '40mm', '4mm', shop, { bold: 1 })
  } else {
    text(lp, '2mm', '2mm', '28mm', '6mm', slot, { size: 14, bold: 1 })
    text(lp, '9mm', '2mm', '40mm', '4mm', info.title)
    text(lp, '13mm', '2mm', '40mm', '8mm', info.accessory || info.care)
    text(lp, '22mm', '2mm', '40mm', '4mm', customer)
    text(lp, '27mm', '2mm', '40mm', '4mm', shop, { bold: 1 })
    if (showQi) text(lp, '9mm', '34mm', '8mm', '6mm', '齐', { size: 12, bold: 1 })
    nativeCode(lp, '6mm', '44mm', '28mm', '10mm', 'barcode', garment.barcode, 90)
    text(lp, '30mm', '44mm', '14mm', '8mm', time.ymdhm, { size: 6 })
  }
}

async function certHtml(garment, ctx, index, total, style) {
  const time = clock()
  const info = piece(garment, index, total, ctx.withAttach !== false)
  const slot = esc(slotOf(ctx.order, garment))
  const code = esc(garment.barcode)
  const bars = code128Svg(garment.barcode, { height: style === 'wideBar' || style === 'short' ? 32 : 64 })
  const qr = style === 'wideQr' ? await qrSvg(garment.barcode) : ''
  const mark = ctx.showQi ? '<b class="mark">齐</b>' : ''
  return `<section class="cert ${style}"><div class="slot">${slot}</div><div class="symbol">${style === 'wideQr' ? qr : bars}</div><div class="nums"><b>${code}</b><span>${style === 'tall' || style === 'tallMark' ? time.ymdhm : time.mdhm}</span></div><div class="copy"><div>${esc(info.title)}</div><div>${esc(info.accessory || info.care)}</div><div>${esc(info.care)}</div><div>${esc(who(ctx.order))}</div><strong>${esc(shopOf(ctx))}</strong></div>${mark}</section>`
}

export async function printWaybill(order, packages, printer, opts = {}) {
  const key = String(order.expressCompany || '').includes('京东') ? 'JD' : 'SF'
  const prefs = await printPrefs()
  const size = String(prefs['print_express_size_' + key] || '100mm × 150mm').replace('×', ' ').replace(/\s+/g, ' ')
  const [w, h] = size.split(' ').filter(Boolean)
  const tenth = [Math.round(parseFloat(w) * 10), Math.round(parseFloat(h) * 10)]
  const preferBrowser = prefs.print_prefer_browser === '1' || opts.forceBrowser
  const lp = preferBrowser ? null : clodop()
  if (lp) {
    try {
      begin(lp, '快递单', tenth, printer || prefs.printer_express)
      text(lp, '6mm', '6mm', '80mm', '8mm', order.expressCompany, { size: 14, bold: 1 })
      text(lp, '16mm', '6mm', '80mm', '10mm', order.expressNo, { size: 16, bold: 1 })
      text(lp, '30mm', '6mm', '80mm', '6mm', `${order.senderName || order.receiverName || ''} ${order.senderPhone || order.phone || ''}`, { size: 11 })
      text(lp, '38mm', '6mm', '80mm', '16mm', [order.senderRegion, order.senderAddress || order.address].filter(Boolean).join(' '), { size: 10 })
      text(lp, '58mm', '6mm', '80mm', '6mm', `${order.orderNo || ''} · ${packages || 1} 个包裹`)
      text(lp, '66mm', '6mm', '80mm', '6mm', order.storeName || '')
      lp.PRINT()
      return true
    } catch { /* 改走浏览器 */ }
  }
  const html = `<section class="waybill"><div class="co">${esc(order.expressCompany)}</div><div class="no">${esc(order.expressNo)}</div><div>${esc(order.senderName || order.receiverName)} ${esc(order.senderPhone || order.phone)}</div><div class="addr">${esc([order.senderRegion, order.senderAddress || order.address].filter(Boolean).join(' '))}</div><div>${esc(order.orderNo)} · ${esc(packages || 1)} 个包裹</div><div>${esc(order.storeName)}</div></section>`
  return openHtml(html, size)
}

const CSS = `
  @page { margin: 0; }
  body { margin: 0; color: #111; font-family: "Microsoft YaHei", "PingFang SC", sans-serif; }
  .wash { width: 100mm; height: 20mm; box-sizing: border-box; padding: 1mm 1.5mm; page-break-after: always; overflow: hidden; }
  .wash .top, .wash .row { display: flex; align-items: center; justify-content: space-between; gap: 1.5mm; }
  .wash .top { font-size: 7px; }
  .wash .bars { width: 36mm; }
  .wash .bars svg { width: 36mm; height: 8mm; display: block; }
  .wash .under { display: flex; justify-content: space-between; font-size: 7px; }
  .wash .qr { display: flex; gap: 1mm; width: 36mm; align-items: center; font-size: 7px; }
  .wash .qr svg { width: 13mm; height: 13mm; }
  .wash .info { flex: 1; min-width: 0; font-size: 7px; line-height: 1.25; }
  .wash .who { font-size: 8px; font-weight: 700; }
  .wash .slot { font-size: 16px; font-weight: 800; }
  .cert { width: 100%; height: 100vh; box-sizing: border-box; padding: 2mm; position: relative; page-break-after: always; }
  .cert .slot { position: absolute; top: 2mm; right: 2mm; font-size: 16px; font-weight: 800; }
  .cert.tall .slot, .cert.tallMark .slot, .cert.short .slot { left: 2mm; right: auto; }
  .cert .symbol svg { display: block; }
  .cert.wideBar .symbol svg { width: 58mm; height: 12mm; }
  .cert.wideQr .symbol svg { width: 16mm; height: 16mm; }
  .cert.short .symbol { position: absolute; left: 2mm; top: 16mm; }
  .cert.short .symbol svg { width: 46mm; height: 12mm; }
  .cert.tall .symbol, .cert.tallMark .symbol { position: absolute; right: 1mm; top: 8mm; width: 14mm; height: 28mm; }
  .cert.tall .symbol svg, .cert.tallMark .symbol svg { width: 28mm; height: 12mm; transform: rotate(90deg); transform-origin: top left; position: absolute; top: 0; left: 12mm; }
  .cert .nums { position: absolute; left: 2mm; top: 15mm; font-size: 8px; display: flex; gap: 4mm; }
  .cert.wideQr .nums { left: 20mm; top: 4mm; font-size: 12px; font-weight: 700; display: block; }
  .cert.wideQr .nums span { display: block; font-size: 8px; font-weight: 400; }
  .cert.tall .nums, .cert.tallMark .nums { left: auto; right: 1mm; top: 32mm; font-size: 6px; }
  .cert.short .nums { top: 30mm; }
  .cert .copy { position: absolute; left: 2mm; right: 2mm; top: 20mm; font-size: 8px; line-height: 1.35; }
  .cert.tall .copy, .cert.tallMark .copy { top: 9mm; right: 16mm; }
  .cert.short .copy { top: 8mm; }
  .cert .mark { position: absolute; right: 2mm; bottom: 6mm; font-size: 14px; }
  .waybill { padding: 6mm; }
  .waybill .co { font-size: 16px; font-weight: 800; }
  .waybill .no { font-size: 20px; font-weight: 800; margin: 2mm 0; }
  .waybill .addr { margin-top: 2mm; }
`

function openHtml(body, size) {
  const w = window.open('', '_blank')
  if (!w) return false
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><style>@page{size:${size};margin:0}${CSS}</style></head><body>${body}</body></html>`)
  w.document.close()
  w.focus()
  w.print()
  return true
}
